// extracted by mini-css-extract-plugin
export default {"info":"logs_info__hkjuo","tips":"logs_tips__WPI1l","content":"logs_content__kyz9A","item":"logs_item__67-xy","header":"logs_header__3D83o","price":"logs_price__c0szG"};